import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { EstadoCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-estado-multiselect',
    templateUrl: './estado-multiselect.component.html',
    styleUrls: ['./estado-multiselect.component.less']
})
export class EstadoMultiselectComponent implements OnInit {
    /** Estados selecionados */
    @Input() idsEstados: number[];
    /** Ao alterar a seleção dos estados */
    @Output() idsEstadosChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Estado';
    @Input() checked = 'Estado';
    @Input() checkedPlural = 'Estados';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum estado encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private estadoCrudHttpService: EstadoCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-estado ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os estados para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        this.estadoCrudHttpService.search()
            .pipe(
                take(1)
            )
            .subscribe(
                entities => {
                    // Adicionando os estados ao multiselect
                    if (entities) {
                        entities.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os estados', error);
                }
            );
    }

    /** Ao alterar a seleção dos estados */
    onChange() {
        this.idsEstadosChange.emit(this.idsEstados);
    }
}
